import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs';

import { PermissionStoreModelEnum } from '@domain/profile';

import { RouteSegments } from '@shared/enums';

import { fromCore } from '@stores/core';

export const permissionGuard = (permissions: PermissionStoreModelEnum[]) => () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(fromCore.selectInitialProfileHasBeenDetermined$).pipe(
    filter((hasBeenDetermined) => hasBeenDetermined),
    switchMap(() =>
      store
        .select(fromCore.selectUserHasPermissions$(permissions))
        .pipe(map((hasPermission) => hasPermission || router.createUrlTree([RouteSegments.Root])))
    )
  );
};
